<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
Program: MonthCondition
Author: SDL
Description: MonthCondition Common Component
-->
<!---->
<template>
  <div class="col-12 quarter-group">
    <div class="col-6 input-group from">
      <wj-input-date :initialized="initFromDate" :value="fromDate" :format="showDateFormat" :value-changed="dateFromChanged" :max="fromDate"></wj-input-date>
    </div>
    <span class="fromto">~</span>
    <div class="col-4 input-group to">
      <wj-input-date :initialized="initToDate" :value="toDate" :format="showDateFormat" :value-changed="dateToChanged" :min="toDate"></wj-input-date>
    </div>
  </div>
</template>
<script>
import * as input from '@grapecity/wijmo.input';
import '@grapecity/wijmo.vue2.input';
import '@grapecity/wijmo.vue2.core';
import { DateUtil, SDLUtil } from '@/utils';

export default {
  name: 'MonthCondition',
  data() {
    return {
      fromDateId: '',
      toDateId: '',
      fromDate: new Date(),
      toDate: new Date(),
    };
  },
  props: {
    returnDateFormat: {
      type: String,
      default: 'YYYY-MM',
    },
    showDateFormat: {
      type: String,
      default: 'yyyy-MM',
    },
  },
  created() {
    // change InpuDate icon to a calendar instead of a down arrow (applies to all InputDate controls)
    input.InputDate.controlTemplate = '<div style="position:relative" class="wj-template">'
        + '<div class="wj-input">'
        + '<div class="wj-input-group wj-input-btn-visible">'
        + '<input wj-part="input" type="text" class="wj-form-control" />'
        + '<span wj-part="btn" class="wj-input-group-btn" tabindex="-1">'
        + '<button class="wj-btn wj-btn-default" type="button" tabindex="-1">'
        + '<span class="wj-glyph-calendar"></span>'
        + '</button>'
        + '</span>'
        + '</div>'
        + '</div>'
        + '<div wj-part="dropdown" class="wj-content wj-dropdown-panel" '
        + 'style="display:none;position:absolute;z-index:100">'
        + '</div>'
        + '</div>';
    //
    // change the format used to show current month/year (affects all InputDate and Calendar controls)
    // wijmo.culture.Globalize.calendar.patterns.y = 'MMMM yyyy';
  },
  computed: {
  },
  methods: {
    initFromDate(date) {
      this.fromDateId = date;
      // day
      // this.fromDateId.selectionMode = 1;
      // month
      this.fromDateId.selectionMode = 2;
      // none
      // this.fromDateId.selectionMode = 0;
    },
    initToDate(date) {
      this.toDateId = date;
      // day
      // this.toDateId.selectionMode = 1;
      // month
      this.toDateId.selectionMode = 2;
      // none
      // this.toDateId.selectionMode = 0;
    },
    dateFromChanged(s) {
      this.fromDate = s.value;
      this.toDateId.min = s.value;
    },
    dateToChanged(s) {
      this.toDate = s.value;
      this.fromDateId.max = s.value;
    },
    getCalendarVal() {
      const rtnList = {
        fromDate: this.fromDate === null ? '' : DateUtil.stdFormat(this.fromDate, this.returnDateFormat),
        toDate: this.toDate === null ? '' : DateUtil.stdFormat(this.toDate, this.returnDateFormat),
      };
      return rtnList;
    },
    changeCalendarVal(data) {
      this.fromDate = data.fromDate;
      this.toDate = data.toDate;
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/common/control/monthCondition/MonthCondition.vue